import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20 28.333q.708 0 1.188-.48.48-.478.479-1.186 0-.71-.479-1.189A1.62 1.62 0 0 0 20 25q-.708 0-1.187.478-.48.48-.48 1.189 0 .708.48 1.186.48.48 1.187.48m0-6.666q.708 0 1.188-.48T21.667 20v-6.667q0-.708-.479-1.188A1.62 1.62 0 0 0 20 11.667q-.708 0-1.187.478-.48.48-.48 1.188V20q0 .708.48 1.187t1.187.48m0 15q-3.459 0-6.5-1.314-3.042-1.311-5.292-3.561T4.647 26.5Q3.333 23.459 3.333 20t1.314-6.5q1.311-3.042 3.561-5.292T13.5 4.645q3.041-1.312 6.5-1.312t6.5 1.312q3.042 1.314 5.292 3.563t3.561 5.292q1.314 3.042 1.314 6.5t-1.314 6.5q-1.311 3.042-3.561 5.292T26.5 35.353q-3.041 1.314-6.5 1.314m0-3.334q5.583 0 9.458-3.875T33.333 20t-3.875-9.458T20 6.667t-9.458 3.875T6.667 20t3.875 9.458T20 33.333"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }